/* eslint-disable */
// @ts-ignore
module.exports = __REACT_NATIVE_CONFIG_WEB__;
